/**
 * Mask a sensitive identifier, showing only the first and last N characters.
 * Example: "37b33744-ab6f-4d81-8b40-51fd0e28f707" → "37**************************07"
 */
export function maskSensitiveValue(
  value: string | null | undefined,
  visibleStart = 2,
  visibleEnd = 2
): string {
  if (!value) {
    return '';
  }

  const trimmed = value.trim();
  if (trimmed.length <= visibleStart + visibleEnd) {
    return '*'.repeat(trimmed.length);
  }

  const prefix = trimmed.slice(0, visibleStart);
  const suffix = trimmed.slice(trimmed.length - visibleEnd);
  const maskedLength = trimmed.length - visibleStart - visibleEnd;

  return `${prefix}${'*'.repeat(maskedLength)}${suffix}`;
}
